import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import useStyles from './styles';
import NoTransactions from '../../assets/bitcoinRewardsSection/NoTransactions.svg';
import dayjs from 'dayjs';
import { numberFormat } from 'helpers/i18n';
import BlueToolTip from 'components/shared/BlueTooltip';
import { Typography } from '@mui/material';
import { ReactComponent as InfoIcon } from 'assets/bitcoinRewardsSection/InfoIconOutlined.svg';

const columns = [
    {
        id: 'transactionDescription',
        label: 'Description',
        minWidth: 200,
        align: 'left'
    },
    { id: 'createdAt', label: 'DATE', minWidth: 150, align: 'left' },

    { id: 'points', label: 'SATOSHI USED', minWidth: 150, align: 'left' },
    {
        id: 'rewardRate',
        label: 'CONVERSION RATE',
        minWidth: 100,
        align: 'left'
    },
    {
        id: 'rewardAmount',
        label: 'REWARD AMOUNT',
        minWidth: 100,
        align: 'right',
        fontWeight: 'bold',
        paddingRight: '20px'
    }
];

export default function TableRedeemed({ rewards, pagination, setPagination }) {
    const classes = useStyles();

    const formatData = (data, property) => {
        switch (property) {
            case 'createdAt':
                return dayjs(data).format('MMM DD, YYYY');
            case 'points':
                return data;
            case 'rewardAmount':
                return `${numberFormat(data, 8, 2)}`;
            case 'rewardRate':
                return new Intl.NumberFormat().format(data);
            case 'transactionDescription':
                return data;
            default:
        }
    };

    const handlePageChange = (event, newPage) => {
        setPagination({ ...pagination, page: newPage });
    };

    const handleRowsPerPageChange = event => {
        setPagination({
            page: 0,
            rowsPerPage: Number(event?.target?.value)
        });
    };

    return (
        <Paper
            sx={{
                width: '97%',
                overflow: 'hidden',
                marginTop: '21px',
                overflowY: 'hidden'
            }}>
            <TableContainer sx={{ maxHeight: 700 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead sx={{ position: 'relative', zIndex: 1 }}>
                        <TableRow>
                            {columns.map(column => (
                                <TableCell
                                    className={classes.headerTableCell}
                                    key={column.id}
                                    align={rewards.results.length === 0 ? 'center' : column.align}
                                    style={{
                                        minWidth: column.minWidth,
                                        width: column.minWidth,
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineHeight: '17px',
                                        color: '#A8B6C1',
                                        backgroundColor: '#F1F3F7',
                                        height: '50px',
                                        textTransform: 'uppercase',
                                        paddingLeft: rewards.results.length > 0 && column.label === 'Description' && '3em'
                                    }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {column.label}
                                        {column.label === 'CONVERSION RATE' && (
                                            <BlueToolTip
                                                placement="top"
                                                arrow
                                                title={
                                                    <Typography className="tooltip-stat-text white-text font-weight-bold">
                                                        Conversion rate is determined at time of redemption by the current market
                                                        spot price as reported by Coinbase
                                                    </Typography>
                                                }>
                                                <InfoIcon
                                                    style={{
                                                        color: 'rgb(168, 182, 193)',
                                                        fontSize: '15px',
                                                        marginLeft: '5px'
                                                    }}
                                                />
                                            </BlueToolTip>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {
                        <TableBody
                            style={{
                                overflowY: 'hidden',
                                height: rewards.results.length === 0 && '600px'
                            }}>
                            {!!rewards.results.length &&
                                rewards.results.map(reward => {
                                    return (
                                        <TableRow role="checkbox" tabIndex={-1} key={reward.id}>
                                            {columns.map(column => {
                                                const value = reward[column.id];
                                                return (
                                                    <TableCell
                                                        className={classes.textRowPrimary}
                                                        key={column.id}
                                                        align={column.align}
                                                        sx={{
                                                            height: '100px',
                                                            p: 0,
                                                            paddingLeft:
                                                                rewards.results.length > 0 &&
                                                                column.id === 'transactionDescription'
                                                                    ? '3.3em'
                                                                    : '1.3em',
                                                            paddingRight: column.paddingRight,
                                                            alignItems: 'center',
                                                            paddingBottom: '20px'
                                                        }}
                                                        style={{
                                                            fontWeight:
                                                                column.id === 'transactionDescription'
                                                                    ? 600
                                                                    : column.id === 'createdAt'
                                                                    ? 700
                                                                    : column.id === 'amount'
                                                                    ? 'bold'
                                                                    : 500,
                                                            height: '66px !important'
                                                        }}>
                                                        {column.id === 'transactionDescription' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px'
                                                                }}>
                                                                <br />
                                                                {reward?.transactionDescription}
                                                            </span>
                                                        )}
                                                        {column.id === 'createdAt' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px'
                                                                }}>
                                                                <br />
                                                                {formatData(value, column.id)}
                                                            </span>
                                                        )}
                                                        {column.id === 'points' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px'
                                                                }}>
                                                                <br />
                                                                {reward?.points}
                                                            </span>
                                                        )}
                                                        {column.id === 'rewardRate' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px'
                                                                }}>
                                                                <br />${reward?.rewardRate}
                                                            </span>
                                                        )}
                                                        {column.id === 'rewardAmount' && (
                                                            <span
                                                                style={{
                                                                    fontWeight: 'bold',
                                                                    fontSize: '13px',
                                                                    lineHeight: '20px',
                                                                    paddingRight: '20px'
                                                                }}>
                                                                <br />
                                                                {formatData(value, column.id)}
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            {rewards.results.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                                        <img src={NoTransactions} alt={'no-transactions'} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    }
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={rewards.total}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Paper>
    );
}
